module.exports = __webpack_public_path__ + "images/bannerES-96271b1f4fe3ca5ba8a8232fb66a1340.png";